const config = {
  local: {
    apiDomain: '/webapp',
    liveDomain: '/welive',
    wxzDomain: '/api',
    basePath: '/test/webapp', // 挂载的二级目录
    appId: 'wxdd1979061033f666',
    openId: 'oQd0LwFd0nlDdQLIDkI2bg-61Z0U',
    qrCodeLink: 'https://letssell.yunkecn.com/test/webapp',
  },
  test: {
    apiDomain: '/test',
    liveDomain: 'https://testlive.yunkecn.com',
    wxzDomain: 'https://testwxzapi.yunkecn.com',
    basePath: '/test/webapp', // 挂载的二级目录
    appId: 'wxdd1979061033f666',
    qrCodeLink: 'https://letssell.yunkecn.com/test/webapp',
    liveUrl: 'http://testliveplay.yunkecn.com',
  },
  production: {
    apiDomain: 'https://letssell.yunkecn.com',
    liveDomain: 'https://www.yunkecn.com/qxxlive',
    wxzDomain: 'https://www.weixiaozhu.com',
    basePath: '/webapp', // 挂载的二级目录
    appId: 'wxdd1979061033f666',
    qrCodeLink: 'https://letssell.yunkecn.com',
    liveUrl: 'http://liveplay.yunkecn.com',
  },
};

const env = process.env.REACT_APP_API_ENV;
const configs = {
  ...config[env],
  apkUrl: 'https://lets-sell.oss-cn-beijing.aliyuncs.com/app-release.apk',

};

export default configs;
